import React from "react";
import { ComponentDivider, SectionHeading, NavigationBtnContainer, EditButtonWrap, FlexCenter, Content } from './styles';
import { withRouter } from "react-router-dom";
import PropTypes from 'prop-types';
import { Col } from "antd";
import { IconsPlaceNew, IconPadding, DataExportPrint } from "../../styles";
import { PagesHeadingWrapper,PageHeadingWrapper } from "../../../MakeAContribution/styles";
import PrintComponents from "react-print-components";
import printIcon from "../../../../../../assets/icons/print.svg";
import history from "../../../../../../history/history";
import { connect } from "react-redux";
import Allocation from "./Components/ReviewAllocation/Allocation";
import FundingInstructions from "./Components/FundingInstructions/FundingInstructions";
import { ContentContainer } from "../../../MakeAContribution/styles";
import ContributionType from "./Components/ContributionType/ContributionType";
import Notice from "./Components/Notice";
import ConfirmationProcessingDetails from "./Components/ConfirmationProcessingDetails/ConfirmationProcessingDetails";
import Alert from "../../../../../../CommonComponents/Info/Alert/Alert";
import BreadcrumbComponent from "../../../../../../CommonComponents/Breadcrumb/Breadcrumb";
import { getContributionData, clearCurrentContribution } from "../../actions";
import { getPrimaryAccount } from "../../../../../../utils/sessionUtil";
import { initiateTracking, recordError } from '../../../../../../utils/commonUtil';
import { FixedWidth, StyleLessButton } from "../../../../../../CommonComponents/commonStyles";
import { GeneralButton } from "../../../../../../CommonComponents/Commons/commonComponents";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import LearnMore from "./Components/LearnMore/LearnMore";
import { ViewContributionAPI } from '../../../../../../services/drupalServices';
import { getTradeCutOffDateAndTime } from '../../../../../../services/apiServices';
import { viewContributionState } from "../../selectors";
let learnMorePopUp = false;

export class ViewContribution extends React.Component {

  constructor(props) {
    super(props);
    this.state = { show: false, noticeContent: "-1" }
    this.handleBack = this.handleBack.bind(this)
  }
  handleBack() {
    try {
      this.analyticsTracking('button','View All Transactions');
      history.push("/contributions/activity");
      window.scrollTo(0, 0);
    } catch (error) {
      recordError(error);
    }
  }

  componentWillMount = () => {
    window.scrollTo(0, 0);
    let data = {};
    if (process.env.REACT_APP_NODE_ENV === "development") {
      data = {
        metaData: {
          method: "GET",
          page: "View Contribution",
          url: {
            view: "/viewContribution/view",
            dropDownValues: "/npaAccount/dropdownValues/dropDown"
          }
        }
      };
    } else {
      data = {
        metaData: {
          method: "GET",
          page: "View Contribution",
          url: {
            view: `/donor-portal/api/contribution/${getPrimaryAccount().userId}/getContribution?transactionId=${history.location.state.transactionId}`,
            dropDownValues: "/donor-portal/api/dropDownValues/getCodeValueMapping"
          }
        }
      };
    }
    this.props.getContributionData(data);
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount = () => {
    this.props.clearCurrentContribution();
  }

  breadcrumbRoutes = () => {
    return [
      {
        routeName: "Home",
        path: "/"
      },
      {
        routeName: "Contributions",
        path: ""
      },
      {
        routeName: "Contribution Activity",
        path: "/contributions/activity"
      },
      {
        routeName: "View Contribution",
        path: ""
      }
    ];
  };

   handleOkay = () => {
    document.body.style.overflow = "";
    this.setState({
      show: true
    });
    learnMorePopUp = false;
  };

  showLearnMore = () => {
    learnMorePopUp = true;
    this.setState({ show: true });
  }

  noticeAPICall = () => {
    const promises = [];
    promises.push(ViewContributionAPI.getNotice());
    promises.push(getTradeCutOffDateAndTime({userId: getPrimaryAccount().userId}));
    Promise.all(promises).then((response) => {
      this.setState({ noticeContent: response[0].data, tradeCutoffDate: response[1].data })
    });
  }

  analyticsTracking = (value, name) => {
    try {
      initiateTracking(value,'View Contribution', '' ,name);
    } catch (error) {
      recordError(error);
    }
  }

  render() {
    const isEdit = (history.location.state === undefined) ? false : history.location.state.isEdit;
    const contribDescription = 'The Transaction ID above confirms you have entered a contribution for Vanguard Charitable. Once we receive and process the asset, a tax substantiation letter is generated and can be found in My Documents. Contributions from private foundations and other charitable organizations will not receive tax substantiation letters.';
    const footNote = '* This transaction has been rebooked. Please call Vanguard Charitable at 888-483-4483 for more information.';
    if (this.state.noticeContent === "-1") {
      this.noticeAPICall();
    }
    if (this.props.transactionData) {
      const { transactionData } = this.props;
       const { checks, funds, securities, specialAssets, wires, backdatedFlag, rkOnlyFlag } =transactionData;
      let transactionStatus;
      checks.length && (transactionStatus = checks[0].giftStatus.extDescription);
      funds.length && (transactionStatus = funds[0].giftStatus.extDescription);
      securities.length && (transactionStatus = securities[0].giftStatus.extDescription);
      specialAssets && specialAssets.length && (transactionStatus = specialAssets[0].giftStatus.extDescription);
      wires.length  && (transactionStatus = wires[0].giftStatus.extDescription);
      
      return (
        <FixedWidth>
          <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
          <PageHeadingWrapper fontSize="42px" mobileFont="36px" marginBottom="50px" mBottom="40px">View Contribution</PageHeadingWrapper>
          { (this.state.noticeContent === "-1") ? '' :
           (this.state.noticeContent.length && this.state.noticeContent[0].field_notice_content ?
          <Alert 
            heading={<div dangerouslySetInnerHTML={{ __html: this.state.noticeContent[0].field_notice_content }} />}
            body={<div dangerouslySetInnerHTML={{ __html: this.state.noticeContent[0].field_show_more_content }} />}
            hideButton={this.state.noticeContent[0].field_show_more_content ? false : true}
          ></Alert> : '')
          }
          <ComponentDivider marginTop="50px" mTop="40px" marginBottom="30px" mBottom="15px" />
          {learnMorePopUp === true ? (
            <LearnMore handleOkay={this.handleOkay} />
          ) : null}
          <FlexCenter >
            <Col lg={{ span: 20 }} md={{ span: 20 }} xs={{ span: 24 }}>
              <ConfirmationProcessingDetails transactionId={history.location.state.transactionId} giftId={history.location.state.giftId} />
            </Col>
            <Col lg={{ span: 4 }} md={{span: 4}} xs={0} >
              <div>
                <IconsPlaceNew>
                  <PrintComponents
                    className="i_print"
                    data-test="print-btn"
                    trigger={
                      <StyleLessButton>
                        <IconPadding className="ml2" >
                          <img src={printIcon} alt="print"/>
                          <DataExportPrint  onClick={() => this.analyticsTracking('print','Print')}>PRINT</DataExportPrint>
                        </IconPadding>
                      </StyleLessButton>
                    }
                  >
                    <div>
                      <FixedWidth>
                        <SectionHeading fontSize="42px" marginBottom="15px" marginTop='50px'>View Contribution</SectionHeading>
                        <Notice message={this.state.noticeContent}></Notice>
                        <ConfirmationProcessingDetails transactionId={history.location.state.transactionId} giftId={history.location.state.giftId} />
                        <Content>{contribDescription}</Content>
                        <ComponentDivider marginTop="30px" marginBottom="30px" />
                        <EditButtonWrap>
                          <SectionHeading fontSize="42px" mobileFont="20px">Contribution Type</SectionHeading>
                        </EditButtonWrap>
                        <ContributionType />
                        <EditButtonWrap>
                          <SectionHeading fontSize="42px" mobileFont="20px">Investment Option Allocation</SectionHeading>
                        </EditButtonWrap>
                        <Allocation />
                        <ComponentDivider />
                        { transactionStatus != "Cancelled" && !rkOnlyFlag && backdatedFlag ? 
                          <Content marginTop="29px" marginBottom="46px" >{ footNote }</Content>
                          : "" }
                      </FixedWidth>
                    </div>
                  </PrintComponents>
                </IconsPlaceNew>
              </div>
            </Col>
            <Col lg={0} md={24} xs={24} >
              <div>
                <IconsPlaceNew>
                  <PrintComponents
                    className="i_print"
                    data-test="print-btn-mob"
                    trigger={
                      <StyleLessButton>
                        <IconPadding>
                          <img src={printIcon}  />
                          <DataExportPrint onClick={() => this.analyticsTracking('print','Print')}>PRINT</DataExportPrint>
                        </IconPadding>
                      </StyleLessButton>
                    }
                  >
                    <div>
                      <ContentContainer>
                        <PageHeadingWrapper marginBottom="15px">View Contribution</PageHeadingWrapper>
                        <Notice message={this.state.noticeContent}></Notice>
                        <ConfirmationProcessingDetails transactionId={history.location.state.transactionId} giftId={history.location.state.giftId} />
                        <Content>{contribDescription}</Content>
                        <ComponentDivider marginTop="30px" marginBottom="30px" />
                        <EditButtonWrap>
                          <SectionHeading>Contribution Type</SectionHeading>
                        </EditButtonWrap>
                        <ContributionType />
                        <EditButtonWrap>
                          <SectionHeading>Investment Option Allocation</SectionHeading>
                        </EditButtonWrap>
                        <Allocation />
                        <ComponentDivider />
                        { transactionStatus != "Cancelled" && !rkOnlyFlag && backdatedFlag ? 
                          <Content marginTop="29px" marginBottom="46px" >{ footNote }</Content>
                          : "" }
                      </ContentContainer>
                    </div>
                  </PrintComponents>
                </IconsPlaceNew>
              </div>
            </Col>

          </FlexCenter>
          <Content>{contribDescription}</Content>

          <ComponentDivider marginTop="20px" marginBottom="40px" />
          <EditButtonWrap>
            <SectionHeading mobileFont="20px">Contribution Type</SectionHeading>
          </EditButtonWrap>
          <ContributionType tradeCutoffDateAndTime={this.state.tradeCutoffDate}/>
          <EditButtonWrap>
            <SectionHeading mobileFont="20px">Investment Option Allocation</SectionHeading>
          </EditButtonWrap>
          <Allocation />
          <ComponentDivider marginTop="30px" marginBottom="30px" />
          <FundingInstructions />
          {
            transactionStatus != "Cancelled" && !rkOnlyFlag && backdatedFlag ? 
            <Content marginTop="29px" marginBottom="46px" >{ footNote }</Content>
            : ""
            }
          <NavigationBtnContainer>
      
                    <GeneralButton 
                      text = "View All Transactions"
                      width = "fit-content"
                      mobWidth = "100%"
                      type = "functional"
                      inverted = {true}
                      onClick={this.handleBack}
                    />
          </NavigationBtnContainer>
        </FixedWidth>
      )
    } else {
      return (
        <Preloader />
      )
    }

  }
}

ViewContribution.propTypes = {
  transactionData: PropTypes.object,
  getContributionData: PropTypes.func,
  clearCurrentContribution: PropTypes.func,

}

const mapStateToProps = (state) => ({
  ...viewContributionState(state.toJS())
})

export const mapDispatchToProps = (dispatch) => ({
  getContributionData: (data) => dispatch(getContributionData(data)),
  clearCurrentContribution: () => dispatch(clearCurrentContribution())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewContribution));


